module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('svg', {
    ref: "chart"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b94d521"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/nvd3-pie-chart.vue
// module id = 586
// module chunks = 4 5 6